<style>
.v-label {
  font-size: 14px;
}
</style>
<template>
<div>
  <v-list>
    <v-list-item v-for="item in value" :key="item.state.stateDesc">
      <v-list-item-action>
        <v-checkbox :label="item.state.stateDesc" v-model="item.value"></v-checkbox>
      </v-list-item-action>
    </v-list-item>
  </v-list>
</div>
</template>
<script>
export default {
  props: {
    value: {
      type: Array,
      default: null
    }
  }
}
</script>
